/**
 * Midgard community links. The Discord invite was supplied by the owner on
 * 2026-10-19 (permanent invite to the "Midgard.one" server); override with
 * REACT_APP_DISCORD_INVITE_URL without a code change.
 */
export const DISCORD_INVITE_URL =
  process.env.REACT_APP_DISCORD_INVITE_URL || 'https://discord.gg/bUPskwPr2M';

export const AFTERRA_URL = 'https://afterra.one';
